import Env from './env'
//判断三种环境是哪种环境
// const ajaxUrl = Env === 'development'
//     ? 'https://haocongcong.f.wmeimob.com'//nginx配置的代理地址server_name（同一局域网）或者外网能访问的接口地址（不是同一局域网）
//     : Env === 'production'
//         ? 'https://ecoa2.lindemobile.cn'
//         : 'http://wx.xianni.wmeimob.com';
//
// const appid = Env === 'development'
//     ? 'wx2916d10ad3693a58'//appid,公众号的ID
//     : Env === 'production'
//         ? 'wx758beeb713e57886'
//         : 'wx1d09d50315914f537';

const mpid =
    Env === 'development' //mpid问后台要，没有就不用了，不用改也不用删不影响
        ? '10115'
        : Env === 'production'
        ? '10115'
        : '10115'
// 8 7
// const loginUrl = 'https://haocongcong.f.wmeimob.com/';//nginx配置的代理地址server_name
// const loginUrl = 'https://ecoa2.lindemobile.cn' //nginx配置的代理地址server_name

// const ajaxUrl = 'https://hepengfei-linde.f.wmeimob.com' 本地地址
const ajaxUrl = 'https://ecoa2.lindemobile.cn' // 线上地址 需要上线用到的
// const ajaxUrl = 'https://ecoa4.lindemobile.cn' // 测试地址
// const ajaxUrl = '/api'
// const appid = 'wx2916d10ad3693a58'
const appid = 'wx758beeb713e57886'
const loginUrl = ajaxUrl

let config = {
    api: ajaxUrl,
    appid,
    mpid,
    loginUrl
}
export default config



// WEBPACK FOOTER //
// ./src/config/index.js